"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _AdoArtifact = require("./AdoArtifact");
Object.keys(_AdoArtifact).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AdoArtifact[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AdoArtifact[key];
    }
  });
});
var _AdoRepositoryType = require("./AdoRepositoryType");
Object.keys(_AdoRepositoryType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AdoRepositoryType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AdoRepositoryType[key];
    }
  });
});
var _Artifact = require("./Artifact");
Object.keys(_Artifact).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Artifact[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Artifact[key];
    }
  });
});
var _ArtifactActions = require("./ArtifactActions");
Object.keys(_ArtifactActions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ArtifactActions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ArtifactActions[key];
    }
  });
});
var _ArtifactIdentifier = require("./ArtifactIdentifier");
Object.keys(_ArtifactIdentifier).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ArtifactIdentifier[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ArtifactIdentifier[key];
    }
  });
});
var _ArtifactMappingExemption = require("./ArtifactMappingExemption");
Object.keys(_ArtifactMappingExemption).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ArtifactMappingExemption[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ArtifactMappingExemption[key];
    }
  });
});
var _ArtifactDisabledItems = require("./ArtifactDisabledItems");
Object.keys(_ArtifactDisabledItems).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ArtifactDisabledItems[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ArtifactDisabledItems[key];
    }
  });
});
var _ArtifactOwnership = require("./ArtifactOwnership");
Object.keys(_ArtifactOwnership).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ArtifactOwnership[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ArtifactOwnership[key];
    }
  });
});
var _ArtifactTagOptions = require("./ArtifactTagOptions");
Object.keys(_ArtifactTagOptions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ArtifactTagOptions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ArtifactTagOptions[key];
    }
  });
});
var _ArtifactAutoAssignment = require("./ArtifactAutoAssignment");
Object.keys(_ArtifactAutoAssignment).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ArtifactAutoAssignment[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ArtifactAutoAssignment[key];
    }
  });
});
var _ArtifactTags = require("./ArtifactTags");
Object.keys(_ArtifactTags).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ArtifactTags[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ArtifactTags[key];
    }
  });
});
var _ArtifactTagsApi = require("./ArtifactTagsApi");
Object.keys(_ArtifactTagsApi).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ArtifactTagsApi[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ArtifactTagsApi[key];
    }
  });
});
var _BuildDefsParameters = require("./BuildDefsParameters");
Object.keys(_BuildDefsParameters).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BuildDefsParameters[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _BuildDefsParameters[key];
    }
  });
});
var _Link = require("./Link");
Object.keys(_Link).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Link[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Link[key];
    }
  });
});
var _ManagementGroup = require("./ManagementGroup");
Object.keys(_ManagementGroup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ManagementGroup[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ManagementGroup[key];
    }
  });
});
var _MruAdoArtifact = require("./MruAdoArtifact");
Object.keys(_MruAdoArtifact).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MruAdoArtifact[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _MruAdoArtifact[key];
    }
  });
});
var _Organization = require("./Organization");
Object.keys(_Organization).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Organization[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Organization[key];
    }
  });
});
var _OwnerType = require("./OwnerType");
Object.keys(_OwnerType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OwnerType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _OwnerType[key];
    }
  });
});
var _Product = require("./Product");
Object.keys(_Product).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Product[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Product[key];
    }
  });
});
var _ProductUser = require("./ProductUser");
Object.keys(_ProductUser).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProductUser[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ProductUser[key];
    }
  });
});
var _Project = require("./Project");
Object.keys(_Project).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Project[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Project[key];
    }
  });
});
var _ProjectVisibility = require("./ProjectVisibility");
Object.keys(_ProjectVisibility).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProjectVisibility[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ProjectVisibility[key];
    }
  });
});
var _ProductArtifactTypes = require("./ProductArtifactTypes");
Object.keys(_ProductArtifactTypes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProductArtifactTypes[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ProductArtifactTypes[key];
    }
  });
});
var _RepositoryDisablerTargetBypassUpdatePayload = require("./RepositoryDisablerTargetBypassUpdatePayload");
Object.keys(_RepositoryDisablerTargetBypassUpdatePayload).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RepositoryDisablerTargetBypassUpdatePayload[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _RepositoryDisablerTargetBypassUpdatePayload[key];
    }
  });
});
var _RepositoryPrivateVisibilityOptions = require("./RepositoryPrivateVisibilityOptions");
Object.keys(_RepositoryPrivateVisibilityOptions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RepositoryPrivateVisibilityOptions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _RepositoryPrivateVisibilityOptions[key];
    }
  });
});